var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "55px",
    viewBox: "0 0 47 55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2984 0L0 0.0460419L0.00478971 53.6L34.352 53.4637L45.6 39.4283L32.8919 26.6867L32.6062 26.3996L32.895 26.115L43.466 15.7409L27.2984 0ZM14.2837 8.86325L27.2398 21.3235L27.5279 21.6L27.8195 21.3243L32.5038 16.9146L32.8001 16.6359L32.5055 16.3525L23.9163 8.11923L23.7924 8L23.6184 8.003L14.5671 8.18659L13.6001 8.20658L14.2837 8.86325ZM30.0909 45.2864L8.00496 23.8257L8 13.6L34.9347 39.7514L35.2 40.0105L34.9606 40.2918L30.7044 45.2613L30.413 45.6L30.0909 45.2864ZM19.2 45.5495L8 35.2L8 45.6L19.2 45.5495Z",
    transform: "translate(0.3601074 0.3600006)",
    id: "Fill-1",
    fill: "#0080FF",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.71e394d8c8ef10d082dff47d2df1c06e.svg";
export { ForwardRef as ReactComponent };